document.addEventListener('DOMContentLoaded', function() {  
    const menuTitles = document.querySelectorAll('summary.header__menu-item');  

    menuTitles.forEach(item => {  
        const menuTitle = item.querySelector('span');  
        if (menuTitle.textContent === "Shop By Category") {  
            const menuGroup = menuTitle.closest('details').querySelectorAll('.row_col');  
            const firstItem = menuGroup[0];  
            const lastItem = menuGroup[menuGroup.length - 1];  
            const menuRow = firstItem.closest('.menu_row');  

            menuRow.style.display = "grid";  
            menuRow.style.gridTemplateColumns = 'repeat(6, 1fr)';  

            if (firstItem) {  
                applyStyles(firstItem, "1/7", "2px solid #D9D9D9", "25px", "30px", false);  
            }  
            if (lastItem) {  
                applyStyles(lastItem, "1/7", "2px solid #D9D9D9", "25px", "30px", true);  
            }  

            for (let index = 1; index < menuGroup.length - 1; index++) {  
                menuGroup[index].style.maxWidth = "none";  
            }  
        }  
    });  

    function applyStyles(element, gridColumn, border, padding, margin, isLastItem) {  
        element.style.gridColumn = gridColumn;  
        element.style.borderBottom = isLastItem ? null : border;  
        element.style.borderTop = isLastItem ? border : null;  
        element.style.maxWidth = "none";  
        
        if (isLastItem) {  
            element.style.paddingTop = padding; // Padding for the last item  
            element.style.marginTop = margin;   
        } else {  
            element.style.paddingBottom = padding; // Padding for the first item  
            element.style.marginBottom = margin;    
        }  

        const submenu = element.querySelector('.header__submenu');  
        if (submenu) {  
            submenu.style.display = 'grid';  
            submenu.style.gridTemplateColumns = 'repeat(6, 1fr)';  
        }  
    }  

    const subMenu = document.querySelectorAll(".menu-drawer__submenu-item--link").forEach(submenu => {
        submenu.addEventListener('click', function(event) {
            event.stopPropagation(); 
            const currentDetails = this.closest('details');
            const allSubmenus = document.querySelectorAll('.details-menu-drawer--submenu');            
            allSubmenus.forEach(detail => {
                if (detail != currentDetails && detail.open) {  
                    detail.open = false; // Close other open details  
                    const otherSubMenuLinks = detail.querySelectorAll('.menu-drawer__submenu-item--link');  
                    otherSubMenuLinks.forEach(link => {  
                        // Optionally, toggle icons if you have them for closed submenus
                        link.querySelector('.icon-down').classList.remove('hidden');  
                        link.querySelector('.icon-up').classList.add('hidden');  
                    });  
                }  
            });

            this.querySelector('.icon-down').classList.toggle('hidden');
            this.querySelector('.icon-up').classList.toggle('hidden');
            if(currentDetails.open){
            currentDetails.open = true;
            } else {
                currentDetails.open = false;
            }
            // console.log(this.closest('details'), "here==>");
            
            const closeSubMenu = this.closest('.details-menu-drawer--submenu').querySelector('.menu-drawer__close-button .return-to-link').textContent;
            
            const closeMenu = this.closest('.menu-drawer__navigation').querySelector('.back-to-link');
            closeMenu.textContent = "";
            closeMenu.textContent = closeSubMenu;
    
        });
    });
});